<template>
    <div class="edit_wrap">
        <div class="edit_top">
            <div class="edit_tab">供应商信息</div><div class="edit_tab">品牌信息</div><div class="edit_tab">财务信息</div><div class="edit_tab active_tab">合同协议</div>
        </div>
        <div class="tip_word">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">友情提示：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<router-link to="/matters"><span style="color: #58b7ff">点击此处</span></router-link>查看供应商入驻介绍。</div></el-col>
            </el-row>
        </div>
        <div class="mt20 ovh min_height">
            <div class="pl10 mt20">
                <span class="dib">合同基本信息</span><span class="line"></span>
                <div class="mt20">
                    <el-form :model="agreeform" ref="agreeform" label-width="207px" class="demo-ruleForm mt10">
                        <el-form-item label="供应商合同编号："><span>{{ agreeform.contractCode }}</span></el-form-item>
                        <el-form-item label="供应商编号："><span>{{ agreeform.suppliersCode }}</span></el-form-item>
                        <el-form-item label="供应商名称："><span>{{ agreeform.suppliersName }}</span></el-form-item>
                        <el-form-item label="合作方式：" prop="cooperationType"
                                      :rules="[
                                      { required: true, message: '请选择合作方式'}]"
                        >
                            <el-select @change="" v-model="agreeform.cooperationType" prop="cooperationType"
                                       placeholder="请选择合作方式">
                                <el-option label="入仓" :value="1"></el-option>
                                <el-option label="入仓（实销实结）" :value="2"></el-option>
                                <el-option label="自发货" :value="3"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="agreeform.cooperationType==3" label="发货时效：">
                            <span class="main_word rule_star92">*</span>
                            <el-select class="ml_10" @change="" v-model="agreeform.deliveryTime"
                                       placeholder="请选择发货时效">
                                <el-option label="48小时" :value="48"></el-option>
                                <el-option label="72小时" :value="72"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="合同开始时间：">
                            <el-date-picker v-model="startTime"
                                            type="date" placeholder="请选择合同开始时间">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="合同结束时间：">
                            <el-date-picker v-model="endTime"
                                            type="date" placeholder="请选择合同结束时间">
                            </el-date-picker>
                        </el-form-item>

                        <span class="dib mt10">主营品牌信息</span><span class="line"></span>
                        <el-table ref="agbl" :data="agreeform.applyAgreementBrandList" border
                                  style="margin: 0 auto;margin-bottom:22px;margin-top: 22px"
                                  @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    width="55">
                            </el-table-column>
                            <el-table-column prop="brandName" label="品牌" width="200" align="center">
                            </el-table-column>
                            <el-table-column label="合作品类" width="180" align="center">
                                <template scope="scope">
                                    <span>{{scope.row.categoryLevel.grandName}}-{{scope.row.categoryLevel.parentName}}-{{scope.row.categoryLevel.childrenName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否提供发票" align="center"  width="170">
                                <template scope="scope">
                                    <el-radio-group v-model="scope.row.provideInvoice" @change="selProvideInvoice(scope.row,scope.store)">
                                        <el-radio :label="0"><span class="f14 f666">否</span></el-radio>
                                        <el-radio :label="1"><span class="f14 f666">是</span></el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="发票类型" align="center" width="180">
                                <template scope="scope">
                                    <el-select :disabled="scope.row.provideInvoice==0" @change="selInvoiceType(scope.row)"
                                               v-model="scope.row.invoiceType"
                                               placeholder="请选择发票类型">
                                        <el-option v-if="agreeform.registeredCountry == 1"  label="增值税普通发票" :value="1"></el-option>
                                        <el-option v-if="agreeform.registeredCountry == 1 && agreeform.taxpayerType==1" label="增值税专用发票" :value="2"></el-option>
                                        <el-option v-if="agreeform.registeredCountry == 1 && agreeform.taxpayerType==2" label="增值税专用发票（需去税务局代开）" :value="2"></el-option>
                                        <el-option v-if="agreeform.registeredCountry != 1" label="形式发票" :value="3"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" align="center" min-width="200">
                                <template scope="scope"
                                          v-if="scope.row.rate !=null && scope.row.rate != undefined ">

                                    <el-radio-group v-model="scope.row.rate" v-if="agreeform.taxpayerType==1 && scope.row.invoiceType==1">
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="0">0%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                                    </el-radio-group>
                                    <el-radio-group v-model="scope.row.rate" v-if="agreeform.taxpayerType==1 && scope.row.invoiceType==2">
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="6">6%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="9">9%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="10">10%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="13">13%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" style="margin-left:0px;" label="16">16%</el-radio>
                                    </el-radio-group>
                                    <el-radio-group v-model="scope.row.rate" v-if="agreeform.taxpayerType==2">
                                        <el-radio :disabled="scope.row.provideInvoice==0" label="0">0%</el-radio>
                                        <el-radio :disabled="scope.row.provideInvoice==0" label="3">3%</el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                        </el-table>
                        <span class="dib">合同条款-财务信息</span><span class="second_line"></span>
                        <el-form-item label="结算主体：" prop="settlementBodyId" :rules="[
                                      { required: true, message: '请选择结算主体'}]">
                            <template scope="scope">
                                <el-select class="w193" @change="" v-model="agreeform.settlementBodyId"
                                           placeholder="请选择结算主体">
                                    <el-option label="北京果敢时代科技有限公司" :value="1"></el-option>
                                    <el-option label="MAMA HONG KONG" :value="2" ></el-option>
                                    <el-option label="天津果敢时代国际贸易有限公司" :value="3"></el-option>
                                    <el-option label="正合奇胜（天津）企业咨询管理有限公司" :value="4"></el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                        <el-form-item label="结算方式：" prop="settlementType" :rules="[
                                      { required: true, message: '请选择结算方式'}]">
                            <template scope="scope">
                                <el-select class="w193" v-model="agreeform.settlementType"
                                           placeholder="请选择结算方式">
                                    <el-option v-show="agreeform.cooperationType ==1" label="直采" :value="1"></el-option>
                                    <el-option v-show="agreeform.cooperationType ==1" label="预付款" :value="2"></el-option>
                                    <el-option v-show="agreeform.cooperationType !=1" label="实销实结" :value="3"></el-option>
                                </el-select>
                            </template>
                        </el-form-item>

                        <el-form-item label="结算币种：">
                            <span class="main_word rule_star92">*</span>
                            <span class="ml_10">人民币</span>
                        </el-form-item>
                        <el-form-item v-if="agreeform.settlementType == 1 || agreeform.settlementType == 3"
                                      label="结算账期：">
                            <span class="main_word rule_star92">*</span>
                            <el-select class="w193" v-model="agreeform.settlementPaymentType">
                                <el-option label="按年结算" :value="2"></el-option>
                                <el-option label="按半年结算" :value="3"></el-option>
                                <el-option label="按季度结算" :value="4"></el-option>
                                <el-option label="按月结算" :value="5"></el-option>
                                <el-option label="按半月结算" :value="6"></el-option>
                                <el-option label="自定义" :value="0"></el-option>
                            </el-select>
                            <el-input v-if="agreeform.settlementPaymentType===0" class="w193" v-model.number="agreeform.settlementPaymentDays" placeholder="请输入结算天数"></el-input>
                            <span v-if="agreeform.settlementPaymentType===0">天</span>


                        </el-form-item>
                        <el-form-item v-if="agreeform.settlementType == 2" label="结算账期：">
                            <el-button type="primary" @click="addDomain">添加分期付款比例</el-button>

                            <!--<span v-for="(paymentRate,index) in agreeform.settlementPaymentRate.split(',')">{{index==0?"":","}}第{{index+1}}期{{ paymentRate }}%</span>-->
                        </el-form-item>
                        <el-form-item v-if="agreeform.settlementType == 2" class="ml60 mt20"
                                      v-for="(domain, index) in agreeform.settlementPaymentRateArr"
                                      :key="'settlementPaymentRate'+index"
                                      :label="'第' + (index+1) + '期'"
                                      :prop="'settlementPaymentRateArr'+'[' + index + ']'"
                                      :rules="{required: true, message: '分期付款比例不能为空', trigger: 'blur'}"
                        >
                            <el-input class="w70" v-model="agreeform.settlementPaymentRateArr[index]"></el-input>
                            %



                            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                        </el-form-item>
                        <!--是否需要保证金-->
                        <el-form-item label="是否需要保证金：">
                            <span class="main_word rule_star133">*</span>
                            <el-radio-group class="ml_10" v-model="agreeform.shouldDeposit" @change="">
                                <el-radio :label="0"><span class="f14 f666">供应商无需交保证金</span></el-radio>
                                <el-radio :label="1"><span class="f14 f666">供应商需交保证金</span></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!--保证金-->
                        <el-form-item label="保证金：">
                            <span class="main_word rule_star78">*</span>
                            <span class="ml_10">{{ agreeform.deposit }} 人民币</span>
                        </el-form-item>
                        <el-form-item label="货款支付方式：">
                            <span class="main_word rule_star120">*</span>
                            <span class="ml_10">甲方将货款直接支付到乙方的如下银行账户</span>
                        </el-form-item>
                        <el-form-item label="开户银行："><span class="main_word rule_star92">*</span><span class="ml_10">{{ agreeform.bankName }}</span></el-form-item>
                        <el-form-item label="银行账号："><span class="main_word rule_star92">*</span><span class="ml_10">{{ agreeform.accountNumber }}</span></el-form-item>
                        <el-form-item label="银行户名："><span class="main_word rule_star92">*</span><span class="ml_10">{{ agreeform.accountName }}</span></el-form-item>
                        <el-form-item v-if="agreeform.registeredCountry != 1" label="SwiftCode："><span class="main_word rule_star99">*</span><span class="ml_10">{{ agreeform.swiftCode }}</span></el-form-item>
                        <el-form-item v-if="agreeform.registeredCountry == 1" label="省："><span class="main_word rule_star50">*</span><span class="ml_10">{{ agreeform.province }}</span></el-form-item>
                        <el-form-item v-if="agreeform.registeredCountry == 1" label="市："><span class="main_word rule_star50">*</span><span class="ml_10">{{ agreeform.city }}</span></el-form-item>
                        <span class="dib">线上合同信息</span><span class="line"></span>

                        <!--选择线上合同-->
                        <div>
                            <el-button class="ml115 mt20" type="primary" @click="selectAgree">选择线上合同</el-button>
                            <span class="main_word"> （请为供应商选择合同，之后直接在线上完成合同相关信息填写）</span>

                        </div>
                        <div style="margin-left: 150px;margin-top: 20px">
                            <div class="agree_wrap" v-for="val in templateContents">
                                <div class="in_block">
                                    <span class="agree">{{ val.name }}</span>
                                    <el-button type="primary" @click="editAgree(val)">编辑</el-button>
                                </div>
                            </div>
                        </div>

                        <!--合同弹框-->
                        <el-dialog title="合同线上模板" :visible.sync="agreeDialog" size="large">
                            <div class="block">
                                <div class="clearfix container">
                                    <div class="row">
                                        <div class="col-lg-3" v-for="val in list" style="width: 20%;">

                                            <el-radio-group v-model="fatherId" @change="argeenSel">
                                                <el-radio :label="val.id"><span class="f16 fwb">{{ val.name }}</span></el-radio>
                                            </el-radio-group>
                                            <!--<span style="font-size:16px;color:#333">{{ val.name }}</span>-->
                                            <div class="mt20">
                                                <template v-for="va in val.subList">
                                                    <div class="mt10">
                                                        <!--<input type="checkbox"-->
                                                        <!--:id="va.id + 'checkbox'"-->
                                                        <!--:value="va.id" v-model="subList">-->
                                                        <!--<label type="checkbox" :for="va.id + 'checkbox'">{{ va.name }}</label>-->
                                                        <el-radio-group v-model="childrenId"
                                                                        @change="argeenChildrenSel">
                                                            <el-radio :label="va.id">{{ va.name }}</el-radio>
                                                        </el-radio-group>
                                                        <br>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="agreeDialog = false">取 消</el-button>
                                <el-button type="primary" @click="saveAgree">确认模板</el-button>
                            </div>
                        </el-dialog>

                        <el-form-item class="auto mt10" label-width="207px">
                            <el-button type="primary" class="mr10" @click="cancleSave">
                                取消

                            </el-button>
                            <el-button class="mr10" type="primary" @click="submit('agreeform')">
                                保存

                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>


</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                // pickerOptions: {
                //     disabledDate(time) {
                //         return time.getTime() < Date.now();
                //     }
                // },
                contentIds: "",
                showDetail: 0,
                applyId: 0,
                agreementId: 0,
                agreementList: [],
                hasEditContract: 1,

                // 合同模板父子Id
                fatherId: 0,
                childrenId: 0,
                templateContents: [],
                // 合同模板列表弹框
                agreeDialog: false,
                // 合同列表数据
                list: [
                    {
                        id: null, //模板id
                        pid: null,
                        name: "",//模板名称
                        fileName: "", //模板文件
                        status: 0,
                        subList: [ //子模板
                        ]
                    }
                ],

                // 合同开始时间
                startTime: '',
                // 合同结束时间
                endTime: '',

                // 数据
                agreeform: {
                    cooperationType: '',
                    deliveryTime: '',
                    applyAgreementBrandList: [
//                        {
//                            brandName: '',
//                            categoryLevel: {
//                                grandName: '',
//                                parentName: '',
//                                childrenName: ''
//                            },
//                            provideInvoice: '',
//                            invoiceType: '',
//                            rateArr: [],
//                        }
                    ],
                    settlementBodyId: '',
                    settlementType: '',
                    settlementPaymentType:0,
                    settlementPaymentDays: null,
                    settlementPaymentRateArr: [''],
                    shouldDeposit: 0,
                    deposit: 0,

                    // 编辑合同协议后，后台返回的合同模板内容id
                    templateContentIds: []
                },

                // 选中品牌项
                selApplyAgreementBrandList: []

            };
        },
        methods: {
            editAgree(val){
                var _this = this;
                if (_this.startTime === "") {
                    this.$message.error("请选择合同开始日期");
                    return;
                }
                if (_this.endTime === "") {
                    this.$message.error("请选择合同结束日期");
                    return;
                }
                var contractStartTime = new Date(this.startTime);
                var contractEndTime = new Date(this.endTime);
                var stTime = contractStartTime.getFullYear() + "-" + (contractStartTime.getMonth() + 1) + "-" + contractStartTime.getDate();
                var endTime = contractEndTime.getFullYear() + "-" + (contractEndTime.getMonth() + 1) + "-" + contractEndTime.getDate();
                window.open("/suppliers/index2/#/" + val.fileName + "_edit?type=0&contentId=" + val.contentId +
                    "&templateId=" + val.templateId +
                    "&bankName=" + _this.agreeform.bankName +
                    "&accountNumber=" + _this.agreeform.accountNumber +
                    "&accountName=" + _this.agreeform.accountName +
                    "&startTime=" + stTime +
                    "&endTime=" + endTime +
                    "&deposit=" + _this.agreeform.deposit +
                    "&suppliersName=" + _this.agreeform.suppliersName +
                    "&agreementCode=" + _this.agreeform.contractCode
                );
            },
            putContentIds(val){
                alert(val);
            },
            fetch () {
                var _this = this;
                var agreementId = this.$route.query.agreementId;
                var suppliersApplyId = this.$route.query.supplierApplyId;
                this.agreementId = agreementId;
                this.applyId = suppliersApplyId;
                //console.log(agreementId)
                if (agreementId && agreementId != 0) {
                    $.get({
                        url: '/suppliers/supplierSettled/agreement/detail',
                        data: {
                            agreementId: agreementId
                        },
                        success: function (result) {
                            if (result.code == 0) {
                                _this.agreeform = result.data;
                                _this.agreeform.agreementName = _this.agreeform.contractName;

                                _this.startTime = result.data.contractStartTime;
                                _this.endTime = result.data.contractEndTime;

                                _this.templateContents = _this.agreeform.templateContents;
                                _this.agreeform.templateContentIds = [];
                                for(var i =0;i < _this.agreeform.templateContents.length;i++){
                                    _this.agreeform.templateContentIds.push( _this.agreeform.templateContents[i].contentId);
                                }
                                _this.$watch('agreeform.settlementType', _this.settlementTypeChange);
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                } else {
                    $.get({
                        url: '/suppliers/supplierSettled/agreement/detail',
                        data: {
                            suppliersApplyId: suppliersApplyId,
                            agreementId: 0
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.agreeform = result.data;
                                //重置表单，否则会出现提示非空验证消息
                                _this.$refs['agreeform'].resetFields();
                                _this.$watch('agreeform.settlementType', _this.settlementTypeChange);
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
            },
            // 选中模板事件
            argeenSel (val) {
                if (this.childrenId == 0) {
                    return;
                }
                for (var i = 0; i < this.list.length; i++) {
                    if (this.list[i].subList) {
                        for (var j = 0; j < this.list[i].subList.length; j++) {
                            var sub = this.list[i].subList[j];
                            if (this.childrenId == sub.id && val != sub.pid) {
                                this.childrenId = 0;
                                break;
                            }
                        }
                    }
                }
            },
            argeenChildrenSel (val) {
                for (var i = 0; i < this.list.length; i++) {
                    if (this.list[i].subList) {
                        for (var j = 0; j < this.list[i].subList.length; j++) {
                            var sub = this.list[i].subList[j];
                            if (val == sub.id) {
                                this.fatherId = sub.pid;
                                break;
                            }
                        }
                    }
                }
            },
            selProvideInvoice(row,store){
                var store = store.states.data;
                if(row.provideInvoice==0) {
                    row.invoiceType = null;
                    row.rate = '';
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 0;
                    }
                } else {
                    for (var i = 0; i < store.length; i++) {
                        store[i].provideInvoice = 1;
                    }
                }
            },
            selInvoiceType(row){
                row.rate = '';
            },
            // 确认模板
            saveAgree (){
                if (!this.fatherId) {
                    this.$message.error('请选择一个合同模板');
                    return;
                }
                if (!this.childrenId) {
                    for (var i = 0; i < this.list.length; i++) {
                        var father = this.list[i];
                        if (father.id == this.fatherId && this.list[i].subList && this.list[i].subList.length > 0) {
                            this.$message.error('当前选择的合同模板包含附加协议，请选择一个附加协议');
                            return;
                        }


                    }
                }
                this.templateContents = [];
                this.agreeform.templateContentIds = [];

                for (var i = 0; i < this.list.length; i++) {
                    var father = this.list[i];
                    if (father.id == this.fatherId) {
                        this.templateContents.push({
                            contentId: 0,
                            templateId: father.id,
                            name: father.name,
                            fileName: father.fileName
                        });
                        this.agreeform.agreementName = father.name;
                    }
                    if (this.list[i].subList) {
                        for (var j = 0; j < this.list[i].subList.length; j++) {
                            var sub = this.list[i].subList[j];
                            if (this.childrenId == sub.id) {
                                this.templateContents.push({
                                    contentId: 0,
                                    templateId: sub.id,
                                    name: sub.name,
                                    fileName: sub.fileName
                                });
                                break;
                            }
                        }
                    }
                }


                this.agreeDialog = false;
            },
            // 时间转化
            transform (val) {
                return new Date(val).getTime();
            },
            getTimeStr (val) {
                var date = new Date(val);
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + ' ';
                return Y + M + D;
            },
            // 选中品牌项
            handleSelectionChange(val) {
                this.selApplyAgreementBrandList = val;
                if(this.selApplyAgreementBrandList){
                    for(var i=0;i<this.selApplyAgreementBrandList.length;i++){
                        if(this.selApplyAgreementBrandList[i].deposit > this.agreeform.deposit){
                            this.agreeform.deposit = this.selApplyAgreementBrandList[i].deposit;
                        }
                    }
                }
            },


            // 添加分期付款比率
            addDomain() {
                this.agreeform.settlementPaymentRateArr.push("");
            },
            removeDomain(item) {
                var index = this.agreeform.settlementPaymentRateArr.indexOf(item);
                if (index !== -1) {
                    this.agreeform.settlementPaymentRateArr.splice(index, 1)
                }
            },
            submit (formName) {
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log('submit!');
                        console.log(this.agreeform);
                        if (this.agreeform.settlementType == 2) {
                            if (this.agreeform.settlementPaymentRateArr.length == 0) {
                                this.$message.error('分期付款比例不能为空');
                                return;
                            }
                            var sum = 0;
                            for (var i = 0; i < this.agreeform.settlementPaymentRateArr.length; i++) {
                                var rate = this.agreeform.settlementPaymentRateArr[i];
                                if (rate == '') {
                                    this.$message.error('分期付款比例不能为空');
                                    return;
                                }
                                rate = rate * 1;
                                if (!typeof(rate) == "number") {
                                    this.$message.error('分期付款比例必须为数字');
                                    return;
                                }
                                sum += rate;
                            }
                            if (sum != 100) {
                                this.$message.error('所有期的百分比加起来必须是100%');
                                return;
                            }

                        } else {
                            if(this.agreeform.settlementPaymentType===0&&(this.agreeform.settlementPaymentDays==null||this.agreeform.settlementPaymentDays===0)){
                                this.$message.error('请输入结算账期天数');
                                return;
                            }
                        }
                        if (this.selApplyAgreementBrandList.length <= 0) {
                            this.$message.error('请选择主营品牌信息');
                            return;
                        } else {
                            for (var i=0;i<this.selApplyAgreementBrandList.length;i++){
                                if(this.selApplyAgreementBrandList[i].provideInvoice==null){
                                    this.$message.error('请选择是否提供发票');
                                } else if(this.selApplyAgreementBrandList[i].provideInvoice==1) {
                                    if(this.selApplyAgreementBrandList[i].invoiceType!=null){
                                        if(this.selApplyAgreementBrandList[i].invoiceType!=3 && this.selApplyAgreementBrandList[i].rate==''){
                                            this.$message.error('请选择发票类型和税率');
                                            return;
                                        }
                                    }else{
                                        this.$message.error('请选择发票类型和税率');
                                        return;
                                    }
                                }

                                if(!this.selApplyAgreementBrandList[i].rate){
                                    this.selApplyAgreementBrandList[i].rateArr = [];
                                }else{
                                    this.selApplyAgreementBrandList[i].rateArr = [this.selApplyAgreementBrandList[i].rate];
                                }
                            }
                        }
                        if (this.agreeform.templateContentIds && this.agreeform.templateContentIds.length != this.templateContents.length) {
                            this.$message.error('请填写线上合同内容');
                            return;
                        }
                        if(this.agreeform.settlementPaymentType >= 2){
                            this.agreeform.settlementPaymentDays = 1;
                        }

                        var data = {};
                        data = JSON.parse(JSON.stringify(this.agreeform));

                        data.contractStartTime = new Date(this.startTime).getTime();
                        data.contractEndTime = new Date(this.endTime).getTime();

                        if (data.contractStartTime && data.contractEndTime){
                            if (data.contractStartTime > data.contractEndTime) {
                                this.$message.error('合同结束时间不能小于合同开始时间');
                                return;
                            }
                        }


                        data.applyId = this.applyId;
                        data.agreementId = this.agreementId;
                        data.agreementBrands = JSON.parse(JSON.stringify(this.selApplyAgreementBrandList));
                        $.ajax({
                            url: '/suppliers/supplierSettled/agreement/save',
                            data: JSON.stringify(data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (result.code == 0) {
                                    _this.$message({
                                        message: '保存成功',
                                        type: 'success'
                                    });
                                    if(window.opener.location.href.indexOf("isStep")>-1){
                                        window.opener.location.reload();
                                    }else{
                                        window.opener.location.href = window.opener.location.href+"&isStep=4";
                                        window.opener.location.reload();
                                    }
                                    window.close();
                                } else {
                                    _this.$message({
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            cancleSave () {
                this.$confirm('此操作将不保存数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.opener = null;
                    window.open('', '_self');
                    window.close();
                }).catch(() => {
                    console.log("取消")
                });
            },

            // 请求合同模板列表
            getAgreeList () {
                var _this = this;
                $.get({
                    url: '/suppliers/contract/template/list',
                    success: function (result) {
                        if (result.code == 0) {
                            console.log(result.data)
                            _this.list = result.data;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            //选择线上合同
            selectAgree(){
                this.agreeDialog = true;
                if (!this.templateContents) {
                    this.fatherId = 0;
                    this.childrenId = 0;
                } else {
                    for (var x = 0; x < this.templateContents.length; x++) {
                        for (var i = 0; i < this.list.length; i++) {
                            if (this.templateContents[x].templateId == this.list[i].id) {
                                this.fatherId = this.list[i].id;
                                continue;
                            }
                            if (this.list[i].subList) {
                                for (var j = 0; j < this.list[i].subList.length; j++) {
                                    var sub = this.list[i].subList[j];
                                    if (this.templateContents[x].templateId == sub.id) {
                                        this.childrenId = sub.id;
                                        continue;
                                    }
                                }
                            }
                        }
                    }
                }
            },

            initAgreementList(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/agreement/list',
                    data: {
                        applyId: supplierApplyId,
                        pageNo: 1,
                        pageSize: 100
                    },
                    success: function (result) {
                        if (!result.code && result.code == 0) {
                            that.agreementList = result.data.data;
                        } else {

                        }
                    }
                })
            },

            // 确认保证金
            confirmDeposit () {
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/confirm/deposit',
                    data: {
                        agreementId: this.supplierApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.$message({
                                message: '确认收到保证金成功',
                                type: 'success'
                            });
                        } else {
                            that.$message.error('确认收到保证金失败，请联系管理员');
                        }
                    }
                })
            },

            // 确认合同
            confirmContract () {
                var Data = {};
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/confirm/contract',
                    data: {
                        agreementId: 9
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.$message({
                                message: '确认收到合同文件成功',
                                type: 'success'
                            });
                            //this.$router.push('/supplier_applies');
                        } else {
                            that.$message.error('确认收到合同文件失败，请联系管理员');
                        }
                    }
                })
            },

            /**
             * 确认驳回资质
             */
            confirmRejectQualification() {
                var that = this;
                this.$prompt('请输入驳回原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入驳回原因'
                }).then(({value}) => {
                    that.rejectQualification(value);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消驳回资质'
                    });
                });
            },

            /**
             * 驳回资质
             * @param content
             */
            rejectQualification (content) {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = 15;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject: 1,
                        content: content
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            that.$message.error('驳回失败，请联系管理员');
                        }
                    }
                })
            },

            /**
             * 确认驳回合同
             */
            confirmRejectContract() {
                var that = this;
                this.$prompt('请输入驳回原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入驳回原因'
                }).then(({value}) => {
                    that.rejectContract(value);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消驳回资质'
                    });
                });
            },

            /**
             * 驳回合同
             * @param content
             */
            rejectContract (content) {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = 15;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject: 2,
                        content: content
                    },
                    success: function (result) {
                        if (!result.code) {
                            this.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            this.$message.error('驳回失败，请联系管理员');
                        }
                    }
                })
            },

            confirmAuditSecond() {
                var that = this;
                this.$confirm('确认审核通过', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.auditSecond();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消复审'
                    });
                });
            },

            auditSecond () {
                var Data = {};
                var that = this;
                that.agreementDetail.suppliersApplyId = 15;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.agreementDetail.suppliersApplyId,
                        reject: 0,
                        content: "同意"
                    },
                    success: function (result) {
                        if (!result.code) {
                            this.$message({
                                message: '复审成功',
                                type: 'success'
                            });
                            window.opener = null;
                            window.open('', '_self');
                            window.close();
                        } else {
                            this.$message.error('复审失败，请联系管理员');
                        }
                    }
                })
            },

            detail(id){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/agreement/detail',
                    data: {
                        agreementId: id
                    },
                    success: function (result) {
                        if (!result.code && result.code == 0) {
                            that.agreementDetail = result.data;
                            if (that.agreementDetail.applyAgreementBrandList) {
                                for (var i = 0; i < that.agreementDetail.applyAgreementBrandList.length; i++) {
                                    if (!that.agreementDetail.applyAgreementBrandList[i].rate) {
                                        that.agreementDetail.applyAgreementBrandList[i].rate = "";
                                    }
                                }
                            }
                            if (that.agreementDetail.templateContents) {
                                that.templateContents = JSON.parse(JSON.stringify(that.agreementDetail.templateContents));
                            }
                            that.showDetail = 1;
                        } else {

                        }
                    }
                })
            },
            reback(){
                this.showDetail = 0;
            },
            settlementTypeChange(val){
                if (val == 2) {
                    this.agreeform.settlementPaymentDays = null;
                    this.agreeform.settlementPaymentType = 1;
                }else{
                    this.agreeform.settlementPaymentType = 5;
                }
            }
        },
        watch: {
            'agreeform.cooperationType': function (val) {
                if(val!=3) {
                    this.agreeform.deliveryTime = null;
                }
                if (val == 1 && this.agreeform.settlementType == 3) {
                    this.agreeform.settlementType = null;
                } else if ((val == 2 || val == 3)) {
                    this.agreeform.settlementType = 3;
                }
            },
            'startTime': function (val) {
                if (this.endTime && val) {
                    if (this.endTime < val) {
                        this.$message.error('合同结束时间不能小于合同开始时间');
                    }
                }
            },
            'endTime': function (val) {
                if (this.startTime && val) {
                    if (val < this.startTime) {
                        this.$message.error('合同结束时间不能小于合同开始时间');
                    }
                }
            }
        },
        mounted () {
            var supplierApplyId = this.$route.query.supplierApplyId;
            this.supplierApplyId = supplierApplyId;
            this.initAgreementList(supplierApplyId);
            this.getAgreeList();
            this.fetch();
        },
        updated(){
            var _this = this;
            if (_this.agreeform.applyAgreementBrandList) {
                for (var i = 0; i < _this.agreeform.applyAgreementBrandList.length; i++) {
                    if (_this.agreeform.applyAgreementBrandList[i].hasCheck) {
                        _this.$refs.agbl.toggleRowSelection(_this.agreeform.applyAgreementBrandList[i],true);
                    }
                }
            }
        },
        created () {
            var _this = this;
            window.eventHub.$on('SET_CONTENT_ID', (data) => {
                if (_this.templateContents) {
                    if (!_this.agreeform.templateContentIds) {
                        _this.agreeform.templateContentIds = [];
                    }
                    for (var x = 0; x < _this.templateContents.length; x++) {
                        if (parseInt(data.templateId) === _this.templateContents[x].templateId) {
                            _this.templateContents[x].contentId = data.contentId;
                            if(_this.agreeform.templateContentIds.indexOf(data.contentId) == -1){
                                _this.agreeform.templateContentIds.push(data.contentId);
                            }
                        }
                    }
                }
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 88%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }

        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }

        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }

        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }

        .pic_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .form_color {
            color: rgb(106, 72, 77);
        }

        .el-form-item {
            margin-bottom: 20px;
        }

        .edit_wrap {
            margin: 50px auto;
            width: 1050px;
            border: 1px solid #eee;
            .edit_tab {
                display: inline-block;
                width: 262px;
                height: 46px;
                background: #ff6c83;
                color: #fff;
                text-align: center;
                line-height: 46px;
            }
            .active_tab {
                background: #ff4a7d;
            }
            .tip_word {
                margin-top: 20px;
                padding: 10px;
                width: 1048px;
                height: 160px;
                background: #f9f9f9;
            }
        }

        .el-form-item {
            margin-top: 10px;
        }

        .w193 {
            width: 193px;
        }

        .w70 {
            width: 70px;
        }

        .w160 {
            width: 160px;
        }

        .ml115 {
            margin-left: 115px;
        }

        .agree_wrap {
            display: inline-block;

        }

        .in_block {
            margin-left: 20px;
        }

        .agree {
            display: inline-block;
            min-width: 100px;

        }
        .rule_star50 {
            position: relative;
            left:-50px;
        }
        .rule_star78 {
            position: relative;
            left:-78px;
        }
        .rule_star92 {
            position: relative;
            left:-92px;
        }
        .rule_star99 {
            position: relative;
            left:-99px;
        }
        .rule_star120 {
            position: relative;
            left:-120px;
        }
        .rule_star133 {
            position: relative;
            left:-133px;
        }
        .ml_10 {
            margin-left: -10px;
        }
        .fwb {
            font-weight: bold;
        }
        .lh20 {
            line-height: 20px;
        }
</style>


// WEBPACK FOOTER //
// agreementList_edit.vue?ee03685c